import { render, staticRenderFns } from "./opFase.vue?vue&type=template&id=2c57f6ae"
import script from "./opFase.vue?vue&type=script&lang=js"
export * from "./opFase.vue?vue&type=script&lang=js"
import style0 from "./opFase.vue?vue&type=style&index=0&id=2c57f6ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports